import type { Timestamp } from "firebase-admin/firestore";

// 상대 시간 포맷팅 함수
export const formatRelativeTime = (dateInput?: Timestamp): string => {
    if (!dateInput) return '';
    let date: Date;
    try {
        date = dateInput instanceof Date ? dateInput : dateInput.toDate();
        if (isNaN(date.getTime())) throw new Error('Invalid date');
    } catch (e) {
        console.warn("Failed to parse date for relative time:", dateInput);
        return ''; // 파싱 실패 시 빈 문자열
    }

    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 5) return '방금 전';
    if (seconds < 60) return `${seconds}초 전`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}분 전`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}시간 전`;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days}일 전`;
    // 7일 이상이면 날짜 표시 (MM/DD)
    return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
};
